import { validate } from './validate';

export const formatBeforeSubmit = (values, addMessage) => {
	const error = validate(values);

	if (error) {
		return addMessage(error, 'error');
	}
	const formattedValues = { ...values };

	formattedValues.time_period = values.time_period.value;
	formattedValues.period_from = values.period_from.value.format('YYYY-MM-DD');
	formattedValues.period_to = values.period_to.value.format('YYYY-MM-DD');
	formattedValues.products = values.products.map((el) => el.value);
	formattedValues.utm_source = values.utm_source?.value;

	return formattedValues;
};
